module.exports = __webpack_public_path__ + "mobileImg/320 главная ст (1).png";